import React from "react";

import Select from "./Select";

export const WIDTHS = [1, 2, 3];

const SelectWidth = (props) => (
  <Select
    type="pixels"
    values={WIDTHS}
    {...props}
  />
);

export default SelectWidth;


// WEBPACK FOOTER //
// ./src/components/Popup/SelectWidth.js